module.exports = __webpack_public_path__ + "img/avatar5_11zon.9d38795a.webp";